<template lang="html">
  <div class="header layoutGrid">
    <router-link to="/" class="p header__title">
      <h1 class="p">John Walker Moosbrugger</h1>
    </router-link>
    <div class="header__nav">
      <router-link to="/" class="p header__nav--item">Portfolio</router-link>
      <router-link to="/about" class="p header__nav--item">About</router-link>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.router-link-active {
  font-weight: 600;
}

.header {
  display: grid;
  align-items: center;
  background-color: white;
  padding: 2rem 0;
  z-index: 100;

  &__title {
    grid-column: 2 / 4;
  }

  &__nav {
    grid-column: 4 / 6;
    text-align: right;

    &--item {
      margin-left: 3rem;
    }
  }
}

@media only screen and (max-width: 330px) {
  .header {
    &__title {
      grid-column: 2 / 6;
      text-align: center;
    }
    &__nav {
      grid-column: 2 / 6;
      text-align: center;

      &--item {
        margin: 0 1.5rem;
      }
    }
  }
}
</style>
